import { Reducer } from 'redux';
import { INITIAL_SALES_ORDER_DEMAND_LIST_STATE } from '../../constants';
import {
    SALES_ORDER_DEMAND_LIST_GET,
    SALES_ORDER_DEMAND_LIST_LOADED,
    SALES_ORDER_DEMAND_LIST_ERROR,
    SALES_ORDER_DEMAND_LIST_PAGE_CHANGE,
    SALES_ORDER_DEMAND_LIST_LOAD_MORE,
    SALES_ORDER_DEMAND_LIST_SORT_CHANGE,
    SALES_ORDER_DEMAND_LIST_FILTER_CHANGE,
    SalesOrderDemandListActions,
} from '../actions/salesOrderDemandActions';
import { SalesOrderDemandListState } from '../types';

export const salesOrderDemandReducer: Reducer<SalesOrderDemandListState, SalesOrderDemandListActions> = (
    state = INITIAL_SALES_ORDER_DEMAND_LIST_STATE,
    action
): SalesOrderDemandListState => {
    switch (action.type) {
        case SALES_ORDER_DEMAND_LIST_GET:
            return {
                ...state,
                salesOrderDemandData: { status: 'Loading', error: undefined, value: undefined },
            };
        case SALES_ORDER_DEMAND_LIST_LOADED:
            return {
                ...state,
                totalRecords: action.payload.totalResults,
                salesOrderDemandData: { status: 'Loaded', error: undefined, value: action.payload.salesOrderDemands },
            };
        case SALES_ORDER_DEMAND_LIST_ERROR:
            return {
                ...state,
                salesOrderDemandData: { status: 'Failed', error: action.payload.error, value: undefined },
            };
        case SALES_ORDER_DEMAND_LIST_PAGE_CHANGE:
            return {
                ...state,
                currentPage: action.payload.currentPage,
                currentRecordNumber: action.payload.currentRecordNumber,
            };
        case SALES_ORDER_DEMAND_LIST_LOAD_MORE:
            return {
                ...state,
                currentPage: action.payload.currentPage,
                startAt: action.payload.currentRecordNumber,
                currentRecordNumber: action.payload.currentRecordNumber,
                salesOrderDemandData: { status: 'Uninitialized', error: undefined, value: undefined },
            };
        case SALES_ORDER_DEMAND_LIST_SORT_CHANGE:
            return {
                ...state,
                currentPage: 1,
                startAt: 0,
                currentRecordNumber: 0,
                sortColumn: action.payload.sortColumn,
                sortDirection: action.payload.sortDirection,
                salesOrderDemandData: { status: 'Uninitialized', error: undefined, value: undefined },
            };
        case SALES_ORDER_DEMAND_LIST_FILTER_CHANGE:
            return {
                ...state,
                currentPage: 1,
                startAt: 0,
                currentRecordNumber: 0,
                poIds: action.payload.poIds ?? state.poIds,
                unitsStatusFilter: action.payload.unitsStatusFilter ?? state.unitsStatusFilter,
                asinFilter: action.payload.asinFilter ?? state.asinFilter,
                resellerSkuFilter: action.payload.resellerSkuFilter ?? state.resellerSkuFilter,
                familyFilter: action.payload.familyFilter ?? state.familyFilter,
                dateRange: action.payload.dateRange ?? state.dateRange,
                dateFilterField: action.payload.dateFilterField ?? state.dateFilterField,
                shipToLocationFilter: action.payload.shipToLocationFilter ?? state.shipToLocationFilter,
                salesOrderDemandData: { status: 'Uninitialized', error: undefined, value: undefined },
            };
        default:
            return state;
    }
};
